import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { MaterialPreviewSection } from './components/MaterialPreviewSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="3ijfv1zlojwem">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      <AnnouncementBar data-id="element-2" data-mp="3mj6jhwnqi0fz" />
      <main data-id="element-3" data-mp="3rbrakqf99zft">
        <HeroSection data-id="element-4" data-mp="3rbzq6q2rjiup" />
        <StatsBar data-id="element-5" data-mp="3rcsyhvhdegey" />
        <TransformationSection data-id="element-6" data-mp="3recedkz46pg7" />
        <PainPointsSection data-id="element-7" data-mp="5os92t1uy7l" />
        <KitContentsSection data-id="element-8" data-mp="4ww9qvjiygs" />
        <MaterialPreviewSection data-id="element-9" data-mp="56qjqnmbrsa" />
        <InstantAccessSection data-id="element-10" data-mp="2zld0746gb58w" />
        <BonusesSection data-id="element-11" data-mp="2zm4xcjfp5b1a" />
        <PricingSection data-id="element-12" data-mp="2zmwit1fkxsdu" />
        <GuaranteeSection data-id="element-13" data-mp="33mouhn09senf" />
        <TestimonialsSection data-id="element-14" data-mp="33m5e4aq9pybi" />
        <FAQSection data-id="element-15" data-mp="33n6zb810016y" />
        <FinalCTASection data-id="element-16" data-mp="33orjq4tlm3r3" />
      </main>
      <Footer data-id="element-17" data-mp="38l8gfnev5qfs" />
    </div>;
}